module.exports = __webpack_public_path__ + "static/media/foyar.9b3326ee.jpg";